unable to read source [project]/node_modules/.pnpm/oauth4webapi@3.8.6/node_modules/oauth4webapi/src/index.ts